import AdChoices from './AdChoices';

export default AdChoices;
